enum FilePickerAction {
    Attach,
    Share,
    Insert, // Insert as an inline image
    AttachAndShare, // This action is responsible to attach the classic attachments and share the reference attachments selected in File Picker
    InsertAsLink, // Insert as a beautiful link
}

export default FilePickerAction;
